import ReferralNotesContainer from './ReferralNotesContainer';

export default ReferralNotesContainer;
